import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Table, TableHead, TableRow, TableCell, TableBody, Button, IconButton, TextField, MenuItem, Select, FormControl, InputLabel, Grid, TablePagination } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useSelector } from 'react-redux';
import { FullDate } from '../../../../components/Date/FullDate';
import dayjs from "dayjs";
import PrintIcon from '@mui/icons-material/Print';

const Expenses = () => {
    const [expenses, setExpenses] = useState([]);
    const [expenseType, setExpenseType] = useState('');
    const [description, setDescription] = useState('');
    const [amount, setAmount] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('Cash');
    const [expenseDate, setExpenseDate] = useState(new Date());
    // const [startDate, setStartDate] = useState(dayjs().subtract(30, "day").format("YYYY-MM-DD")); // Last 30 days
    const [startDate, setStartDate] = useState("2025-01-01"); // Fixed start date
    const [endDate, setEndDate] = useState(dayjs().format("YYYY-MM-DD")); // Today's date
    const [page, setPage] = useState(0);
    const [workers, setWorkers] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedUserDetail, setSelectedUserDetail] = useState(null);
    const api = useSelector((state) => state.Api);
    const initExp = useRef(false)
    // Handle Page Change
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Handle Rows Per Page Change
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    useEffect(() => {
        fetchExpenses();
        // fetchShare();
    }, [endDate]);

    const fromDate = dayjs(startDate).format('YYYY-MM-DD');
    const toDate = dayjs(endDate).format('YYYY-MM-DD');

    const fetchShare = async () => {
        const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;

        try {
            const response = await axios.get(
                api.showShareHold,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${userToken}`,
                    },
                }
            );

            if (response.status === 200) {
                const noPartners = response?.data?.filter(item => item.user_role !== 1);
                setWorkers(noPartners);
            }
        } catch (err) {
            console.error('Error fetching Capital:', err);
        }
    };

    const fetchExpenses = async () => {
        if (initExp.current) return
        initExp.current = true
        const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;

        try {
            const response = await axios.post(
                api.showExpenses,
                { startDate: fromDate, endDate: toDate }, // Send formatted dates
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${userToken}`,
                    },
                }
            );

            if (response.status === 200) {
                //console.log(response.data);
                const salaryAndDep = response?.data?.filter(item => item.expense_type != 'معاش' && item.expense_type != 'ایډوانس' && item.expense_type != 'اډوانس')
                setExpenses(salaryAndDep);
            }
        } catch (err) {
            console.error('Error fetching expenses:', err);
        }
    };

    const addExpense = async () => {
        const userToken = JSON.parse(localStorage.getItem('User_Data'))?.token || undefined;
        let descript = '';
        //console.log(description)
        if (expenseType === "معاش" || expenseType === "ایډوانس") {
            descript = `${selectedUserDetail?.username} ${expenseType}`
        }
        else {
            descript = description
        }
        // return false
        try {
            const response = await axios.post(
                api.addExpenses, // Use the API endpoint for adding expenses
                {
                    expense_type: expenseType,
                    description: descript,
                    amount: parseFloat(amount),
                    // payment_method: paymentMethod,
                    expense_date: expenseDate.toISOString().split('T')[0], // Format date as YYYY-MM-DD
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${userToken}`,
                    },
                }
            );

            if (response.status === 200 || response.status === 201) {
                //console.log('Expense added successfully:', response.data);
                fetchExpenses(); // Refresh the expenses list
                // Reset form fields
                setExpenseType('');
                setDescription('');
                setAmount('');
                // setPaymentMethod('Cash');
                setExpenseDate(new Date());

                const salaryAndDep = response?.data?.data?.filter(item => item.expense_type != 'معاش' && item.expense_type != 'ایډوانس' && item.expense_type != 'اډوانس')
                setExpenses(salaryAndDep);
            }
        } catch (error) {
            console.error('Error adding expense:', error);
        }
    };

    const ChangeDateFrom = (e) => {
        setStartDate(`${e.$y}-${e.$M + 1}-${e.$D}`)
    }
    const ChangeDateTo = (e) => {
        setEndDate(`${e.$y}-${e.$M + 1}-${e.$D}`)
    }
    const handleChange = (e) => {
        const getUser = workers.find(user => user.user_id === e.target.value);

        setSelectedUserDetail(getUser)
        // setInvestBy(getUser)
        setSelectedUser(e.target.value);

    }
    const handleExpenseTypeChange = (e) => {
        //console.log(e.target.value);
        setExpenseType(e.target.value);
        if (e.target.value == "معاش" || e.target.value == "ایډوانس") {
            setDescription('');
        } else {
            setSelectedUser(null);
        }
    };

    const [filters, setFilters] = useState({
        amount: '',
        type: '',
        description: '',
        date: '',
    });

    const filteredExpenses = expenses.filter((expense) => {
        return (
            expense.amount.toString().includes(filters.amount) &&
            expense.expense_type.toLowerCase().includes(filters.type.toLowerCase()) &&
            expense.description.toLowerCase().includes(filters.description.toLowerCase()) &&
            expense.expense_date.toLowerCase().includes(filters.date.toLowerCase())
        );
    });

    const canSubmit =
        amount.trim() !== '' &&
        (!["معاش", "ایډوانس"].includes(expenseType) || selectedUser !== null);

    const totalAmount = filteredExpenses.reduce((sum, expense) => sum + Number(expense.amount), 0);

    const handlePrint = (rows) => {
        console.log(rows)
        try {
            if (!rows || rows.length === 0)
                return alert("No rows to print.");

            const storeInfo = {
                logo: localStorage.getItem("businessLogo") || "",
                businessName: localStorage.getItem("businessName"),
            };

            const printWindow = window.open("", "_blank");

            // const footerRemarks = `<tr><td colspan=4>ټوټل بیلینس	 </td> <td> ${totalBalance}</td></tr>`

            const newTableRows = rows
                .map(
                    (row) => `
          <tr>
            <td>${row?.purchase_order_id || ""} <br/> ${row?.created_at}</td> 
            <td>${row?.description || ""}</td> 
            <td>${row?.expense_type || ""}</td>
            <td>${row?.amount?.toFixed(2) || ""}</td>
          </tr>`
                )
                .join("");

            const logoPath = storeInfo.logo
                ? storeInfo.logo
                : "/images/logos/Logo.png";

            const styles = `
      <style>
        @page {
          size: A4;
          margin: 15mm;
        }
        body {
          font-family: 'Noto Naskh Arabic', sans-serif;
          margin: 0;
          background-color: white;
           background-repeat: no-repeat;
          background-position: center 50%;
          background-size: 60%;
          -webkit-print-color-adjust: exact !important;
        }
          .page {
          width: 210mm;
          min-height: 297mm;
          padding: 10px;          /* ✅ 10px left & right */
          box-sizing: border-box;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          font-size: 13px;
        }
        th, td {
          border: 1px solid #ddd;
          padding: 4px;
          text-align: center;
        }
        thead {
          display: table-header-group; 
          color: white;
        }
        tbody tr:nth-child(odd) {
          background-color: #f9f9f9;
        }
        .header-info {
          text-align: center;
          font-size: 13px;
          padding: 4px 0;
        }
        .logo {
          max-width: 60px;
        }
        footer {
          text-align: center;
          font-size: 11px;
          margin-top: 10px;
        }
      </style>
    `;

            const printHTML = `
      <html lang="ps">
        <head>
          <meta charset="UTF-8" />
          <title>بیل</title>
          ${styles}
        </head>
        <body>
  <div class="page">
    <table>
              <thead>
                <tr style="color: black">
                  <td colspan="6" class="header-info" style="border:0px">
                    <div style="display:flex; justify-content:space-between; align-items:center;">
                      <div style="float: right; text-align: right;">
                      <h3 style="margin: 0; padding:0px; font-size: 12px">
                        مصارف
                      </h3>
                        </div>
                      <div style="text-align:left;">
                        <img src="${logoPath}" class="logo" />
                        <h2 style="font-size:12px; margin:0;">${storeInfo.businessName || ""}</h2>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr style="background-color: #ffa800">
                  <th>تاریخ	</th> 
                  <th>تفصیل</th>  
                  <th>مصارف</th>  
                  <th>افغانی</th>  
                </tr>
              </thead>
              <tbody>
                ${newTableRows}
              </tbody>
            </table>
          </div>

          <footer>© ${new Date().getFullYear()} ${"واصلي ټیکنالوژي 0703131865"}</footer>

          <script>
            window.onload = () => {
              window.print();
              window.onafterprint = () => window.close();
            };
          </script>
        </body>
      </html>
    `;

            printWindow.document.open();
            printWindow.document.write(printHTML);
            printWindow.document.close();
        } catch (err) {
            console.error("Error printing bill:", err);
        }
    };

    return (
        <div>
            <Grid container>
                <Grid item lg={12}>
                    <h3 style={{ textAlign: 'center' }}> Expense  مصارف </h3>
                    {/* <h3 style={{ textAlign: 'center' }}>لاندې تاسو کولی شئ د مصارف راپور شروع تاریخ او تر تاریخ اخیر پوری وپلټئ</h3> */}
                    {/* <IconButton aria-label="print" onClick={() => handlePrint(filteredExpenses)}>
                        <PrintIcon />
                    </IconButton> */}
                </Grid>
            </Grid>

            <>
                {expenses.length >= 1 ? (
                    <>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>
                                        افغانی
                                        <TextField
                                            variant="standard"
                                            size="small"
                                            value={filters.amount}
                                            onChange={(e) => setFilters({ ...filters, amount: e.target.value })}
                                            fullWidth
                                        />
                                    </TableCell>
                                    <TableCell>
                                        مصارف
                                        <TextField
                                            variant="standard"
                                            size="small"
                                            value={filters.type}
                                            onChange={(e) => setFilters({ ...filters, type: e.target.value })}
                                            fullWidth
                                        />
                                    </TableCell>
                                    <TableCell>
                                        تفصیل
                                        <TextField
                                            variant="standard"
                                            size="small"
                                            value={filters.description}
                                            onChange={(e) => setFilters({ ...filters, description: e.target.value })}
                                            fullWidth
                                        />
                                    </TableCell>
                                    <TableCell>
                                        تاریخ
                                        <TextField
                                            variant="standard"
                                            size="small"
                                            value={filters.date}
                                            onChange={(e) => setFilters({ ...filters, date: e.target.value })}
                                            fullWidth
                                        />
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {filteredExpenses
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((expense) => (
                                        <TableRow key={expense.expense_id}>
                                            <TableCell>؋{expense.amount}</TableCell>
                                            <TableCell>{expense.expense_type}</TableCell>
                                            <TableCell>{expense.description}</TableCell>
                                            <TableCell>{expense.expense_date}</TableCell>
                                        </TableRow>
                                    ))}

                                {/* Total row */}
                                <TableRow>
                                    <TableCell style={{ fontWeight: 'bold', textAlign: 'left' }}>
                                        {totalAmount}
                                    </TableCell>
                                    <TableCell colSpan={3}>ټوټل</TableCell>
                                </TableRow>
                            </TableBody>

                        </Table>

                        {/* Pagination Component */}
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 50]}
                            component="div"
                            count={expenses.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </>
                ) : null}
            </>

             
        </div>
    );
};

export default Expenses;
